/**
 * Color PropTypes
 *
 * PropType definitions for color-related components, particularly lens colors
 * and color display elements used in product customization.
 *
 * @module propTypes/color
 */

import PropTypes from "prop-types";

/**
 * Lens color shape
 * Represents a lens color option with display name and CSS color value
 *
 * @property {string} name - Internal color name
 * @property {string} displayName - User-friendly display name
 * @property {string} cssColor - CSS color value (e.g., "blue", "#0000FF")
 */
export const lensColorShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  cssColor: PropTypes.string.isRequired,
});

/**
 * Flexible color prop type
 * Accepts either a string (color name) or a color object with full details
 */
export const colorPropType = PropTypes.oneOfType([PropTypes.string, lensColorShape]);
